module.exports = __webpack_public_path__ + "img/bz.0a08ca3d.png";